import { Controller } from '@hotwired/stimulus'
import { visit } from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['select']
  static values = { status: String }

  connect() {
    this.updateSelection()
  }

  change(event) {
    const url = event.target.value
    if (url) {
      visit(url)
    }
  }

  updateSelection() {
    const select = this.selectTarget
    const currentStatus = this.statusValue

    // Find and select the correct option
    Array.from(select.options).forEach(option => {
      const url = new URL(option.value, window.location.origin)
      const params = new URLSearchParams(url.search)
      const optionStatus = params.get('status')

      if (currentStatus === '' && !optionStatus) {
        option.selected = true
      } else if (currentStatus === optionStatus) {
        option.selected = true
      } else {
        option.selected = false
      }
    })
  }
}
